module.exports = __webpack_public_path__ + "fonts/Alibaba-PuHuiTi-Regular.8d591595.ttf";